import React, { Component, Fragment } from 'react';
import Container from '@material-ui/core/Container';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import DashboardLayout from '../../layouts/DashboardLayout';
import { fetchPublishedPapers } from '../../actions/examPaperAction';
import { fetchExamPapers } from '../../actions/examPaperAction';
import PublishExamPaperResult from '../../components/PublishedExamPaper/ResultsCard';
import keycloakService from '../../keycloakService';

const styles = {
  resultGrid: {
    marginTop: 50
  }
};
class PublishedExamPapers extends Component {
  constructor() {
    super();
    this.state = {
      local: ''
    };
    this.handleLocalization = this.handleLocalization.bind(this);
  }
  componentDidMount() {
    const { fetchPublishedPapers, fetchExamPapers, selectedLanguage } = this.props;
    const userDetails = keycloakService.getUserDetails();
    fetchPublishedPapers(userDetails.sub);
    fetchExamPapers(userDetails.sub, { status: 'PENDING,DRAFT' });
    this.setState({ local: selectedLanguage });
  }
  componentDidUpdate(preProps) {
    const { selectedLanguage } = this.props;
    if (selectedLanguage !== preProps.selectedLanguage) {
      this.setState({ local: selectedLanguage });
    }
  }
  handleLocalization(heading) {
    const { local } = this.state;
    console.log('local', local);
    if (heading == 'published_exam_papers') {
      if (local == 'sinhala') {
        return 'ප්‍රකාශිත විභාග ප්‍රශ්න පත්‍ර';
      } else if (local == 'tamil') {
        return 'தேர்வுத் தாள்கள் வெளியிடப்பட்டன';
      } else {
        return 'Published Exam Papers';
      }
    }
  }
  render() {
    const { publishedPapers, classes } = this.props;
    return (
      <Fragment>
        <DashboardLayout>
          <Container>
            <div>
              <h2>{this.handleLocalization('published_exam_papers')}</h2>
            </div>
            <div className={classes.resultGrid}>
              <PublishExamPaperResult publishedExamPapers={publishedPapers} />
            </div>
          </Container>
        </DashboardLayout>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  publishedPapers: state.examPaper.publishedPapers,
  selectedLanguage: state.language.selectedLanguage
});

const mapDispatchToProps = {
  fetchPublishedPapers,
  fetchExamPapers
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PublishedExamPapers));
